import { render, staticRenderFns } from "./NewDatepickerWrapper.vue?vue&type=template&id=2ece468d&scoped=true&"
import script from "./NewDatepickerWrapper.vue?vue&type=script&lang=js&"
export * from "./NewDatepickerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NewDatepickerWrapper.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewDatepickerWrapper.vue?vue&type=style&index=1&id=2ece468d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece468d",
  null
  
)

export default component.exports